export const endDatePtList = [
  {
    id: "完成予定",
    name: "完成予定",
  },
  {
    id: "検査予定",
    name: "検査予定",
  },
  {
    id: "仕上げ・ｾｯﾄ予定",
    name: "仕上げ・ｾｯﾄ予定",
  },
  {
    id: "保温予定",
    name: "保温予定",
  },
  {
    id: "水張・洗予定",
    name: "水張・洗予定",
  },
  {
    id: "仮組・本溶接予定",
    name: "仮組・本溶接予定",
  },
  {
    id: "つなぎ予定",
    name: "つなぎ予定",
  },
  {
    id: "罫書・穴開予定",
    name: "罫書・穴開予定",
  },
  {
    id: "パネル出庫予定",
    name: "パネル出庫予定",
  },
];

export const endDatePvList = [
  {
    id: "完成予定",
    name: "完成予定",
  },
  {
    id: "仕上予定",
    name: "仕上予定",
  },
  {
    id: "水圧予定",
    name: "水圧予定",
  },
  {
    id: "洗い予定",
    name: "洗い予定",
  },
  {
    id: "コイル予定",
    name: "コイル予定",
  },
  {
    id: "熱交換予定",
    name: "熱交換予定",
  },
  {
    id: "胴部予定",
    name: "胴部予定",
  },
  {
    id: "自動予定",
    name: "自動予定",
  },
  {
    id: "内周予定",
    name: "内周予定",
  },
  {
    id: "仮組予定",
    name: "仮組予定",
  },
  {
    id: "鏡部予定",
    name: "鏡部予定",
  },
  {
    id: "部品予定",
    name: "部品予定",
  },
  {
    id: "長手予定",
    name: "長手予定",
  },
  {
    id: "曲げ予定",
    name: "曲げ予定",
  },
  {
    id: "開先予定",
    name: "開先予定",
  },
  {
    id: "NC予定",
    name: "NC予定",
  },
  {
    id: "鏡予定",
    name: "鏡予定",
  },
  {
    id: "脚予定",
    name: "脚予定",
  },
];

export const completeDatePtList = [
  {
    id: "罫書・穴あけ完了",
    name: "罫書・穴あけ完了",
  },
  {
    id: "工作完了",
    name: "工作完了",
  },
  {
    id: "つなぎ完了",
    name: "つなぎ完了",
  },
  {
    id: "仮組・本溶接完了",
    name: "仮組・本溶接完了",
  },
  {
    id: "水張・洗い完了",
    name: "水張・洗い完了",
  },
  {
    id: "保温完了",
    name: "保温完了",
  },
  {
    id: "仕上・セット完了",
    name: "仕上・セット完了",
  },

  {
    id: "検査完了",
    name: "検査完了",
  },
  {
    id: "未登録",
    name: "未登録",
  },
];
export const completeDatePvList = [
  {
    id: "仕上完了",
    name: "仕上完了",
  },
  {
    id: "水圧完了",
    name: "水圧完了",
  },
  {
    id: "洗い完了",
    name: "洗い完了",
  },
  {
    id: "コイル完了",
    name: "コイル完了",
  },
  {
    id: "熱交換完了",
    name: "熱交換完了",
  },
  {
    id: "胴部完了",
    name: "胴部完了",
  },
  {
    id: "自動完了",
    name: "自動完了",
  },
  {
    id: "内周完了",
    name: "内周完了",
  },
  {
    id: "仮組完了",
    name: "仮組完了",
  },
  {
    id: "鏡部完了",
    name: "鏡部完了",
  },
  {
    id: "部品完了",
    name: "部品完了",
  },
  {
    id: "長手完了",
    name: "長手完了",
  },
  {
    id: "曲げ完了",
    name: "曲げ完了",
  },
  {
    id: "開先完了",
    name: "開先完了",
  },
  {
    id: "NC完了",
    name: "NC完了",
  },
  {
    id: "鏡完了",
    name: "鏡完了",
  },
  {
    id: "脚完了",
    name: "脚完了",
  },
];
